<template>
 <TourGuide>
  <TopNav/>
  <div class="container">
    <LeftNav/>
    <div class="d-flex flex-direction-column dashboard-middle">
      <div v-if="!projects.length" class="d-flex flex-direction-column align-items-center">
        <WaveIcon class="wave-icon"/>
        <h3>Hi There! Start by Creating a project.</h3>
        <button 
          @click="$store.dispatch('showProjectModal', {showModal: true, editingProject: {color: `#48B587`}})" 
          class="primary"
        >
          Create a Project
        </button>
        <EditProjectModal/>
      </div>

      <div v-if="selectedProject" class="d-flex align-items-center justify-content-between dashboard-top-actions">
        <span class="todos-label">To-dos</span>
        <button @click="addGoalClicked()" class="primary d-flex gap-5">
          <PlusIcon/> Add Goal
        </button>
        <EditGoalModal v-if="showGoalsModal"/>
      </div>
    
      <div v-if="!creatingSubTasks && !selectedGoal" class="create-task" style="display: none;">
        <h2>What's a goal You want to crush?</h2>
        <div class="textarea-background">
          <textarea
            name="goal-name"
            placeholder="Gotta type something in here bub..."
            v-model="newGoal"
          ></textarea>
        </div>
        <div class="action-buttons">
          <button
            data-text="AI Generate"
            class="secondary"
            @click.prevent="createGoalClicked(false)"
          >
            Add
          </button>
          <button
            data-text="AI Generate"
            class="primary"
            @click.prevent="createGoalClicked(true)"
          >
            AI Generate
          </button>
        </div>
      </div>

      <LoadingSpinnerIcon v-else-if="!selectedGoal" />
      <div class="d-flex" v-if="goals">
        <ul id="accordion">
          <GoalsListV2 :goals="goals" @toggle-accordion="toggleAccordion"/>
        </ul>
      </div>
    </div>

    <TaskSlider2 v-if="sliderOpen"/>
  </div>
  </TourGuide>
</template>

<script>
import goalsService from '@/services/goalsService';
import LoadingSpinnerIcon from '@/components/LoadingSpinner.vue';
import GoalsListV2 from '@/components/GoalsListV2.vue';
import TaskSlider2 from '@/components/TaskSlider2.vue';
import LeftNav from '@/components/LeftNav.vue';
import TopNav from '@/components/TopNav.vue';
import PlusIcon from '@/components/icons/PlusIcon.vue';
import EditGoalModal from '@/components/EditGoalModal.vue';
import WaveIcon from '@/components/icons/WaveIcon.vue';
import EditProjectModal from '@/components/EditProjectModal.vue';
import TourGuide from '@/components/TourGuide.vue';

import { mapGetters } from 'vuex';

export default {
  name: 'App',
  components: {
    LoadingSpinnerIcon,
    TaskSlider2,
    GoalsListV2,
    LeftNav,
    PlusIcon,
    TopNav,
    EditGoalModal,
    WaveIcon,
    EditProjectModal,
    TourGuide
  },
  computed: {
    ...mapGetters(['sliderOpen','projects','selectedProject','goals','openSections','showGoalsModal'])
  },
  data() {
    return {
      newGoal: '',
      response: null,
      creatingSubTasks: false,
      tasks: [],
      makeApiCall: true,
      activeIndex: null,
      selectedGoal: null,
      showModal: false
    };
  },
  methods: {
    addGoalClicked() {
      this.$store.commit('setActiveGoal', {
        ai_generate_tasks: true,
        handle_subtasks: '',
        goal: '',
        due_date: null
      });
      this.$store.commit('setShowGoalsModal', true);
    },
    openModal(docUrl) {
      const modal = document.createElement('div');
      modal.id = 'doc-modal';
      modal.style.position = 'fixed';
      modal.style.top = '50%';
      modal.style.left = '50%';
      modal.style.transform = 'translate(-50%, -50%)';
      modal.style.width = '80%';
      modal.style.height = '80%';
      modal.style.backgroundColor = '#fff';
      modal.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
      modal.style.zIndex = '1000';
      modal.innerHTML = `
        <iframe src="${docUrl}" style="width: 100%; height: 100%; border: none;"></iframe>
        <button id="close-modal" style="position: absolute; top: 10px; right: 10px;">Close</button>
      `;
      document.body.appendChild(modal);

      document.getElementById('close-modal').addEventListener('click', () => {
        modal.remove();
      });
    },
    toggleAccordion(index) {
      this.$store.commit('setOpenSections', {
        ...this.openSections,
        [index]: !this.openSections[index]
      });
    },
    setSelectedProject(project) {
      this.$store.dispatch('setSelectedProject', project);
      this.$store.dispatch('selectTask', null);
      this.selectedGoal = null;
    },
    async createGoalClicked(aiEnhance) {
      try {
        this.creatingSubTasks = true;
        let goal = { goal: this.newGoal, aiEnhance, project_id: this.selectedProject.id };
        const result = await goalsService.createGoal(goal);
        this.$store.dispatch('getGoals', this.selectedProject.id);
        this.newGoal = '';
        this.tasks = result.tasks; // Assuming backend returns tasks
      } catch (error) {
        console.error('Error fetching tasks:', error);
      } finally {
        this.creatingSubTasks = false;
      }
    },
    getActiveTaskStyling(index) {
      let classString = 'task';
      if (this.activeIndex == null) {
        return classString;
      }
      if (index === this.activeIndex || index === this.activeIndex - 1) {
        classString += ' active-task-border ';
      }
      if (index === this.activeIndex) {
        classString += ' active-task-background ';
      }
      return classString;
    },
    onGoalSelected(goal) {
      this.selectedGoal = goal;
    }
  }
};
</script>

<style scoped>
.wave-icon {
  width: 150px;
  height: 150px;
}

/* Original desktop style: keep 48rem, centered */
.dashboard-top-actions {
  width: 48rem;
  padding-bottom: 10px;
}

.dashboard-middle {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 80px; /* This is causing extra space at the top on mobile */
}

/* #accordion also at 48rem on desktop */
#accordion {
  width: 48rem;
}

.todos-label {
  font-family: var(--body-font);
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: var(--dark-colo-a0);
}

textarea {
  height: 5rem;
}

.textarea-background {
  background-color: #383838;
  border-radius: 15px;
  display: flex;
  padding: 15px;
}

/* Accordion transitions */
.accordion-enter-active,
.accordion-leave-active {
  transition: max-height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}
.accordion-enter-from,
.accordion-leave-to {
  max-height: 0;
  opacity: 0;
}
.accordion-enter-to,
.accordion-leave-from {
  max-height: 300px;
  opacity: 1;
}

/* Hide Button */
.hide-button {
  display: none;
}

/* Modal Background */
#modal {
  display: none;
  position: fixed;
  top: 0; 
  left: 0;
  width: 100%; 
  height: 100%;
  background-color: rgba(0,0,0,0.7);
  z-index: 1000;
}

/* Modal Content */
#modal-content {
  display: none;
  position: absolute;
  top: 50%; 
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%; 
  height: 80%;
  background-color: var(--white-color);
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  overflow: hidden;
}

/* Close Button */
#close-btn {
  position: absolute;
  top: 10px; 
  right: 10px;
  background-color: #ff5f57;
  border: none;
  color: var(--white-color);
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
}
#close-btn:hover {
  background-color: #ff3b3b;
}

/* Iframe Styling */
iframe {
  width: 100%;
  height: 100%;
  border: none;
}

/* 
  MOBILE OVERRIDE:
  - Let .dashboard-middle shrink top margin 
  - Let #accordion & .dashboard-top-actions auto-width so they don't overflow
  - Add some margin so "Add Goal" button isn't too close
*/
@media (max-width: 768px) {
  .dashboard-middle {
    margin-top: 20px; /* reduce from 80px */
    padding: 0 1rem;  /* add some horizontal padding */
    width: 100%; 
    align-items: flex-start; /* no longer center on mobile */
    box-sizing: border-box;
  }

  .dashboard-top-actions {
    width: 100% !important;
    margin-bottom: 1rem; /* space below "To-dos" row */
  }

  #accordion {
    width: auto !important;
  }
}
</style>
